import Body from "app/components/Form/Body"
import InputField from "app/components/Form/Field/Input"
import SelectField from "app/components/Form/Field/Select"
import Heading from "app/components/Heading"
import Description from "app/components/Description"
import { useTranslate } from "hooks/translate"
import { getAppLocale } from "state/app/selectors"
import investmentTooltipNL from "assets/img/tooltip-investment-nl.jpg"
import investmentTooltipNL2x from "assets/img/tooltip-investment-nl@2x.jpg"
import investmentTooltipFR from "assets/img/tooltip-investment-fr.jpg"
import investmentTooltipFR2x from "assets/img/tooltip-investment-fr@2x.jpg"
import { validateAmount, validateMax, validateMin } from "app/validation"
import { Navigate } from "react-router-dom"
import {
  getLeadResponseStatus,
  getVerifyLeadResponse
} from "state/form/selectors"
import { useFormContext } from "react-hook-form"
import { useSelector } from "react-redux"
import { FormStateData } from "state/form/types"

import { useEffect } from "react"
import { CarModels } from "app/enums/carModels.enum"
import { RequestStatus } from "state/types"
import { useAppflow } from "app/hooks/useAppFlow"
import { CarEnum } from "app/pages/appFlow/types"

const carModels = [
  {
    key: "polestar_2",
    value: CarModels.POLESTAR_2
  },
  {
    key: "polestar_3",
    value: CarModels.POLESTAR_3
  },
  {
    key: "polestar_4",
    value: CarModels.POLESTAR_4
  },
  {
    key: "polestar_5",
    value: CarModels.POLESTAR_5
  }
]

const tooltipImg = {
  nl: {
    src: investmentTooltipNL,
    srcSet: `${investmentTooltipNL} 1x, ${investmentTooltipNL2x} 2x`
  },
  fr: {
    src: investmentTooltipFR,
    srcSet: `${investmentTooltipFR} 1x, ${investmentTooltipFR2x} 2x`
  },
  en: {
    src: investmentTooltipNL,
    srcSet: `${investmentTooltipNL} 1x, ${investmentTooltipNL2x} 2x`
  }
}

const MIN_INVESTMENT_AMOUNT = 30000
const MAX_INVESTMENT_AMOUNT = 150000

const Step3: React.FC = () => {
  const { data: verified, status: verifyStatus } = useSelector(
    getVerifyLeadResponse
  )
  const { t } = useTranslate()
  const locale = useSelector(getAppLocale)
  const { isRejected } = useSelector(getLeadResponseStatus)
  const { clearErrors, setError } = useFormContext<FormStateData>()
  const { clientType, carType } = useAppflow()

  const carModelOptions = carModels
    .filter(
      model => carType === CarEnum.New || model.value !== CarModels.POLESTAR_5
    )
    .map(model => ({
      label: t(`system.car_model.${model.key}`),
      value: model.value
    }))

  useEffect(() => {
    if (verified) clearErrors()
  }, [verified])

  useEffect(() => {
    if (verifyStatus === RequestStatus.REJECTED) {
      setError("verificationCode", {
        message: t("error.verification_code_valid")
      })
    }
  }, [verifyStatus])

  if (isRejected) {
    return <Navigate to="/error" replace />
  }

  return (
    <>
      <Body>
        <Heading>{t(`form.step_3.${clientType}.heading`)}</Heading>
        <Description>{t(`form.step_3.${clientType}.body`)}</Description>
      </Body>
      <SelectField
        name="carModel"
        label="form.field.car_model.label"
        options={carModelOptions}
        rules={{ required: true }}
      />
      <InputField
        name="grossInvestmentAmount"
        label="system.gross_investment_amount"
        inputMode="numeric"
        rules={{
          required: true,
          validate: {
            amount: validateAmount,
            min: validateMin(MIN_INVESTMENT_AMOUNT),
            max: validateMax(MAX_INVESTMENT_AMOUNT)
          }
        }}
        tooltip={
          <img
            {...tooltipImg[locale]}
            width={260}
            height={290}
            style={{ display: "block" }}
          />
        }
      />
    </>
  )
}

export default Step3
